import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const Wrapper = ({ children, className }) => {
  const classes = classNames({
    'create-wizard-layout-wrap': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Wrapper.propTypes = propTypes;

export default Wrapper;
